/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetSidebarState200ResponseDataRegistriesCountRegistriesByType } from './GetSidebarState200ResponseDataRegistriesCountRegistriesByType'
import {
  GetSidebarState200ResponseDataRegistriesCountRegistriesByTypeFromJSON,
  GetSidebarState200ResponseDataRegistriesCountRegistriesByTypeFromJSONTyped,
  GetSidebarState200ResponseDataRegistriesCountRegistriesByTypeToJSON,
} from './GetSidebarState200ResponseDataRegistriesCountRegistriesByType'

/**
 * Количество пользовательских регистров с разбивкой по типам
 * @export
 * @interface GetSidebarState200ResponseDataRegistriesCount
 */
export interface GetSidebarState200ResponseDataRegistriesCount {
  /**
   * Количество регистров у пользователя
   * @type {number}
   * @memberof GetSidebarState200ResponseDataRegistriesCount
   */
  registries: number
  /**
   *
   * @type {GetSidebarState200ResponseDataRegistriesCountRegistriesByType}
   * @memberof GetSidebarState200ResponseDataRegistriesCount
   */
  registriesByType: GetSidebarState200ResponseDataRegistriesCountRegistriesByType
}

/**
 * Check if a given object implements the GetSidebarState200ResponseDataRegistriesCount interface.
 */
export function instanceOfGetSidebarState200ResponseDataRegistriesCount(
  value: object
): value is GetSidebarState200ResponseDataRegistriesCount {
  if (!('registries' in value) || value['registries'] === undefined)
    return false
  if (!('registriesByType' in value) || value['registriesByType'] === undefined)
    return false
  return true
}

export function GetSidebarState200ResponseDataRegistriesCountFromJSON(
  json: any
): GetSidebarState200ResponseDataRegistriesCount {
  return GetSidebarState200ResponseDataRegistriesCountFromJSONTyped(json, false)
}

export function GetSidebarState200ResponseDataRegistriesCountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSidebarState200ResponseDataRegistriesCount {
  if (json == null) {
    return json
  }
  return {
    registries: json['registries'],
    registriesByType:
      GetSidebarState200ResponseDataRegistriesCountRegistriesByTypeFromJSON(
        json['registriesByType']
      ),
  }
}

export function GetSidebarState200ResponseDataRegistriesCountToJSON(
  value?: GetSidebarState200ResponseDataRegistriesCount | null
): any {
  if (value == null) {
    return value
  }
  return {
    registries: value['registries'],
    registriesByType:
      GetSidebarState200ResponseDataRegistriesCountRegistriesByTypeToJSON(
        value['registriesByType']
      ),
  }
}
